var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"new-category-side-form-container"},[_c('NewCategoryForm',{attrs:{"is-side-form":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }